/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import {FolderShareProps} from './FolderShared';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) DashboardShare Icon component.
 */
export const DashboardShare = ({color, size, folderColor, ...props}: FolderShareProps) => {
  const {iconSize = 24, iconColor = dlsColor('grey1')} = useIconDLS({color, size});
  return (
    <ThemeIconProvider name='DashboardShare' size={size} color={color} folderColor={folderColor} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        {folderColor && (<rect x='-4' y='9' width='8' height='11' fill={folderColor} rx='1' ry='1'/>)}
        <g fill={iconColor}>
          <path d='M10 10v1H6v-1h4zm5 3v1H6v-1h9zm-3 6v1H6v-1h6zm5-3v1H6v-1h11zM3 10h1v10H3V10zM19.702 11.23a1.5 1.5 0 1 1-.622.785l-2.34-1.672a1.5 1.5 0 1 1 .127-1.459l2.32-1.657a1.5 1.5 0 1 1 .777.674l-2.46 1.758 2.198 1.57zM15.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm5-3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm0 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z'/>
        </g>
      </svg>
    )} />
  );
};

export default DashboardShare;
